import { Stepper } from "@/ds";

import { PASSO_REVISAO_LABEL, PASSOS_ARIA_LABEL } from "./conflito-passos.constants";
import styles from "./conflito-passos.module.scss";
import type { ConflitoPassosProps } from "./types-conflito-passos";

export function ConflitoPassosView({
  etapa,
  selecionarLabel,
  intermediarioLabel,
}: ConflitoPassosProps) {
  const passos = [
    { id: "selecionar", titulo: selecionarLabel },
    ...(intermediarioLabel ? [{ id: "intermediario", titulo: intermediarioLabel }] : []),
    { id: "revisao", titulo: PASSO_REVISAO_LABEL },
  ];
  const atual = passos.findIndex((passo) => passo.id === etapa);

  return (
    <Stepper.Root
      aria-label={PASSOS_ARIA_LABEL}
      className={styles.passos}
      testId="resolver-conflito-steps"
    >
      {passos.map((passo, index) => {
        const state = index < atual ? "done" : index === atual ? "active" : "pending";
        return (
          <Stepper.Step
            key={passo.id}
            className={styles.passo}
            classNames={{ separator: styles.separador }}
            state={state}
            number={index + 1}
            title={passo.titulo}
            testId={`resolver-conflito-step-${index + 1}`}
            data-status={state === "done" ? "completed" : state}
          />
        );
      })}
    </Stepper.Root>
  );
}
